import { createAction } from 'app-components/flux/core/actionHelpers';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from '../../root-ui';

export const createErrorDialog = createAction(rootUiActions.createDialog.toString(), (error) =>
  rootUiTypes.mkRootUiData({
    type: 'DIALOG_CONFIRMATION',
    allowNesting: false,
    props: ImmutableMap({
      title: error.title,
      content: `${error.text} ${error.statusCode ? `Care Code: ${error.statusCode}` : ''}`,
      confirmLabel: error.actionLabel,
      confirmAction: error.action,
      denyLabel: 'Cancel',
      unregisterContentViewOnClose: true,
    }),
  }),
);
